import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { SUPPORTED_LOCALES, DEFAULT_LOCALE, LOCALE_STORAGE_KEY } from 'i18n/config';
import { useSyncLocale } from 'i18n/useSyncLocale';

const detectPreferredLocale = () => {
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
  if (stored && SUPPORTED_LOCALES.includes(stored)) {
    return stored;
  }

  const browserLanguages = navigator.languages || [navigator.language];
  const matched = browserLanguages
    .map((lang) => lang.split('-')[0])
    .find((lang) => SUPPORTED_LOCALES.includes(lang));

  return matched || DEFAULT_LOCALE;
};

export const LocaleGuard = ({ children }) => {
  const { lang } = useParams();
  const location = useLocation();

  if (!SUPPORTED_LOCALES.includes(lang)) {
    const rest = location.pathname.replace(`/${lang}`, '');
    return <Navigate to={`/${DEFAULT_LOCALE}${rest}${location.search}`} replace />;
  }

  return <LocaleSync lang={lang}>{children}</LocaleSync>;
};

const LocaleSync = ({ lang, children }) => {
  useSyncLocale(lang);
  return children;
};

// Redirects an unprefixed URL (e.g. /website/..., /profile/...) to the same URL under
// the visitor's preferred locale.
export const LocaleRedirect = () => {
  const location = useLocation();
  const locale = detectPreferredLocale();

  return <Navigate to={`/${locale}${location.pathname}${location.search}`} replace />;
};
